import React from 'react'

import AppLayout from '@microsites/components/AppLayout'
import EULALayout from '@microsites/components/EULALayout/EULALayout'

import Content from './privacy.md'

/**
 * This is a Privacy Policy page. Before modifying or removing,
 * contact Fireworks legal team.
 */
export default function PrivacyPage() {
  return <Content />
}

PrivacyPage.getLayout = (page) => {
  return (
    <AppLayout>
      <EULALayout>{page}</EULALayout>
    </AppLayout>
  )
}
